/**
 * Copyright (c) 2023 Wizart Animation.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Wizart Animation.
 */

export const entityPermissions = {
    CAN_SEE: "canSee",
    CAN_CREATE: "canCreate",
    CAN_EDIT: "canEdit",
    CAN_EDIT_ONLY_OWN: "canEditOnlyOwn",
    CAN_DELETE: "canDelete",
};

export const advancedPermissions = {
    CAN_ACCESS_ADMIN: "canAccessAdmin",
    CAN_EDIT_WEBHOOKS: "canEditWebhooks",
    CAN_SEE_ALL_PAGES: "canSeeAllPages",
    CAN_SEE_ALL_PROJECTS: "canSeeAllProjects",
    CAN_SET_DEFAULT: "canSetDefaults",
    CAN_WRITE_TO_FREELANCERS: "canWriteToFreelancers",
};

const permissionNames = {
    entity: entityPermissions,
    advanced: advancedPermissions,
};

export default permissionNames;
